// src/lib/auth.js
// Build-safe selector between dev JSON auth and Firebase auth.
// Uses static imports so Vite/esbuild can parse the file.

import * as dev from './authDev.js'
import * as fb from './authFirebase.js'

const backend = (import.meta.env.VITE_DATA_BACKEND || 'dev').toLowerCase()
const api = backend === 'firebase' ? fb : dev

// Export only what the app actually uses.
// (Add more lines here if you expose additional helpers later.)
export const signIn = api.signIn
export const signOut = api.signOut
export const getSession = api.getSession

// Optional: if either implementation exposes an event API,
// you can safely no-op it when absent.
// export const onSessionChanged = api.onSessionChanged || (() => () => {})